let quickSearchTimeout = null
export const protectors = {
    state: {
        status: 'idle',
        protectors: [],
        fullStatus: 'idle',
        fullQuickSearch: [],
        areAllFetched: false,
        pagination: {
            limit: 20,
            page: 1
        },
        query: {
            type: 'all',
            note: '0'
        },
        protectorsTypes: [
            {
                value: 'all',
                label: 'Wszystkie'
            }, {
                value: 'pesticide',
                label: 'Pestycydy'
            }, {
                value: 'notpesticide',
                label: 'Niepestycydy'
            }
        ],
        favoritesTypes: [
            {
                value: 'protectors',
                label: 'Pestycydy i niepestycydy'
            }, {
                value: 'agrii-protectors',
                label: 'Produkty Agrii'
            }
        ],
        protectorsRelated: [
            {
                value: 'related',
                label: 'Dostępne pojemności'
            }
        ],
        protectorsNoteTypes: [
            {
                value: '1',
                label: 'tak'
            },
            {
                value: '0',
                label: 'nie'
            }
        ],
        searchBy: {
            name: '',
            link: ''
        }
    },
    mutations: {
        SET_PROTECTORS_STATUS(state, status) {
            state.status = status
        },
        SET_PROTECTORS(state, protectors) {
            state.protectors = protectors
        },
        SET_PROTECTORS_QUERY(state, payload) {
            this.$vue.set(state.query, payload.name, payload.value)
        },
        REMOVE_PROTECTORS_QUERY_ELEMENT(state, payload) {
            this.$vue.delete(state.query, payload)
            if(payload === 'searchBy') {
                this.$vue.set(state.searchBy, 'name', '')
                this.$vue.set(state.searchBy, 'link', '')
            }
        },
        SET_PROTECTORS_PAGINATION_PAGE(state, page) {
            state.pagination.page = page
        },
        SET_PROTECTORS_ALL_FETCHED(state, areAllFetched) {
            state.areAllFetched = areAllFetched
        },
        SET_FULL_QUICKSEARCH_STATUS(state, status) {
            state.fullStatus = status
        },
        SET_FULL_QUICKSEARCH(state, quickSearch) {
            state.fullQuickSearch = quickSearch
        },
        RESET_FULL_QUICKSEARCH(state) {
            state.fullQuickSearch = []
        },
        SET_PROTECTORS_SEARCH_BY(state, payload) {
            this.$vue.set(state.searchBy, 'name', payload.name)
            this.$vue.set(state.searchBy, 'link', payload.link)
        }
    },
    actions: {
        fetchProtectors({ state, commit, dispatch, getters }, payload) {
            commit('SET_PROTECTORS', [])
            commit('SET_PROTECTORS_STATUS', 'loading')
            commit('SET_PROTECTORS_QUERY', {
                name: 'eko',
                value: getters['eko/status']
            })
            let customUrl = false
            if (payload && payload.isSubstitutes) {
                customUrl = `api/protectors/substitutes/${payload.id}.json`
            } else {
                customUrl = state.searchBy.link !== '' ? state.searchBy.link : 'api/protectors.json'
            }

            return dispatch('resetProtectorsPagination').then(() => {
                return this.$api.get(`${customUrl}?${getters.protectorsQueryString}`).then((response) => {
                    commit('SET_PROTECTORS', response.data.data)
                    commit('SET_PROTECTORS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.protectors.length : response.data.data.length === 0)
                    commit('SET_PROTECTORS_STATUS', 'idle')
                }).catch(error => {
                    if(error.message) {
                        commit('SET_PROTECTORS_STATUS', 'error')
                    }
                    return Promise.reject(error)
                })
            })
        },
        fetchProtectorsNextPage({ state, commit, getters }, payload) {
            if(state.areAllFetched) {
                return false
            }
            commit('SET_PROTECTORS_STATUS', 'loadingMore')
            commit('SET_PROTECTORS_QUERY', {
                name: 'eko',
                value: getters['eko/status']
            })
            commit('SET_PROTECTORS_PAGINATION_PAGE', state.pagination.page + 1)
            let customUrl = false
            if (payload && payload.isSubstitutes) {
                customUrl = `api/protectors/substitutes/${payload.id}.json`
            } else {
                customUrl = state.searchBy.link !== '' ? state.searchBy.link : 'api/protectors.json'
            }

            return this.$api.get(`${customUrl}?${getters.protectorsQueryString}`).then((response) => {
                commit('SET_PROTECTORS', state.protectors.concat(...response.data.data))
                commit('SET_PROTECTORS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.protectors.length : response.data.data.length === 0)
                commit('SET_PROTECTORS_STATUS', 'idle')
            }).catch(error => {
                if(error.message) {
                    commit('SET_PROTECTORS_STATUS', 'error')
                }
                return Promise.reject(error)
            })
        },
        setProtectorsSearchQuery({ state, commit }, payload) {
            // check if payload has valid properties
            if(Object.prototype.hasOwnProperty.call(payload, 'name') &&
               Object.prototype.hasOwnProperty.call(payload, 'value')) {
                commit('SET_PROTECTORS_QUERY', payload)
                // custom relations
                if(payload.name === 'type') {
                    commit('REMOVE_PROTECTORS_QUERY_ELEMENT', 'protector_types')
                }
                if(payload.name === 'type' && payload.value !== 'pesticide') {
                    commit('REMOVE_PROTECTORS_QUERY_ELEMENT', 'agrofags')
                    commit('REMOVE_PROTECTORS_QUERY_ELEMENT', 'producent')
                }
                if(payload.name === 'type' && payload.value === 'notpesticide') {
                    commit('REMOVE_PROTECTORS_QUERY_ELEMENT', 'active_substances')
                }
            } else {
                console.error('Invalid payload')
            }
        },
        removeProtectorsQueryElementAndFetch({ commit, dispatch }, payload) {
            commit('REMOVE_PROTECTORS_QUERY_ELEMENT', payload)
            return dispatch('fetchProtectors')
        },
        resetProtectorsQueryAndFetch({ commit, dispatch }) {
            return dispatch('resetProtectorsQuery').then(() => {
                return dispatch('fetchProtectors')
            })
        },
        resetProtectorsQuery({ commit, dispatch }) {
            commit('SET_PROTECTORS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'protectors',
                object: 'query'
            }).then(() => {
                return dispatch('resetFromInitialState', {
                    module: 'protectors',
                    object: 'searchBy'
                })
            })
        },
        resetProtectorsPagination({ commit, dispatch }) {
            commit('SET_PROTECTORS_ALL_FETCHED', false)
            return dispatch('resetFromInitialState', {
                module: 'protectors',
                object: 'pagination'
            })
        },
        resetProtectorsFavorite({ commit }) {
            commit('REMOVE_PROTECTORS_QUERY_ELEMENT', 'favorite')
        },
        fetchFullQuickSearch({ state, commit }, payload) {
            commit('SET_QUICKSEARCH_STATUS', 'loading')

            if (quickSearchTimeout) clearTimeout(quickSearchTimeout)
            quickSearchTimeout = setTimeout(() => {
                let params = ''
                if(payload.params) {
                    params = `&${Object.entries(payload.params)
                        .filter(([key, value]) => value !== '')
                        .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                        .join('&')}`
                }
                commit('RESET_QUICKSEARCH')
                return this.$api.get(`api/full/search.json?search=${payload.query}${params}`).then((response) => {
                    commit('SET_QUICKSEARCH', response.data.data)
                    commit('SET_QUICKSEARCH_STATUS', 'idle')
                }).catch(error => {
                    if(error.message) {
                        commit('SET_QUICKSEARCH_STATUS', 'error')
                    }
                    return Promise.reject(error)
                })
            }, 500)
        },
        setProtectorsSearchBy({ commit }, payload) {
            commit('SET_PROTECTORS_SEARCH_BY', payload)
        },
        async fetchProtectorSubstitutes({ state, getters, dispatch, commit }, payload) {
            commit('SET_PROTECTORS', [])
            commit('SET_PROTECTORS_STATUS', 'loading')
            commit('SET_PROTECTORS_QUERY', {
                name: 'eko',
                value: getters['eko/status']
            })
            try {
                await dispatch('resetProtectorsPagination')
                const response = await this.$api.get(`api/protectors/substitutes/${payload.id}.json?${getters.protectorsQueryString}`)
                commit('SET_PROTECTORS', response.data.data)
                commit('SET_PROTECTORS_ALL_FETCHED', response.data.total_count ? response.data.total_count <= state.protectors.length : response.data.data.length === 0)
                commit('SET_PROTECTORS_STATUS', 'idle')
                return response
            } catch (error) {
                if(error.message) {
                    commit('SET_PROTECTORS_STATUS', 'error')
                }
                return Promise.reject(error)
            }
        }
    },
    getters: {
        protectorsStatus: (state) => {
            return state.status
        },
        protectorsTypes: (state) => {
            return state.protectorsTypes
        },
        favoritesTypes: (state) => {
            return state.favoritesTypes
        },
        protectorsRelated: (state) => {
            return state.protectorsRelated
        },
        protectorsNoteTypes: (state) => {
            return state.protectorsNoteTypes
        },
        protectors: (state) => {
            if(state.protectors) {
                return state.protectors
            }
        },
        protectorsForSelect: (state) => {
            if(state.protectors) {
                return state.protectors.map(item => {
                    return {
                        value: item.id,
                        label: item.name
                    }
                })
            }
        },
        protectorsQuery: (state) => {
            return state.query
        },
        protectorsQueryString: (state) => {
            const pagination = `page=${state.pagination.page}&limit=${state.pagination.limit}`
            const params = Object.entries(state.query)
                .filter(([key, value]) => value !== '')
                .map(([key, val]) => `${key}=${encodeURIComponent(val)}`)
                .join('&')
            return `${pagination}&${params}`
        },
        protectorsQueryFilters: (state) => {
            if(state.searchBy && state.searchBy.link) {
                return [
                    {
                        name: 'searchBy',
                        value: state.searchBy.name
                    }
                ]
            }
            // build array with parameters
            return Object.entries(state.query)
                .filter(([key, value]) => key !== 'type' && key !== 'eko' && value !== '' && value !== '0')
                .map(([key, value]) => {
                    return {
                        name: key,
                        value: key === 'note' ? 'notatka' : value
                    }
                })
        },
        fullQuickSearchStatus: (state) => {
            return state.fullStatus
        },
        fullQuickSearch: (state) => {
            if(state.fullQuickSearch) {
                return state.fullQuickSearch
            }
        }
    }
}
